<template>
   <v-container fluid>
      <v-toolbar dense :color="$globalstore.settings_titleclass">
         <v-toolbar-title>
            <template v-if="$vuetify.breakpoint.mobile">
               <v-icon large class="mr-2" @click="goBack()">mdi-chevron-left</v-icon>
            </template>
            Holidays
         </v-toolbar-title>
         <v-spacer></v-spacer>
         <v-btn small outlined class="primary white--text" @click="addHoliday">
            <v-icon small>mdi-plus</v-icon>
            Add
         </v-btn>
      </v-toolbar>
      <v-row class="pt-1 mt-1">
         <v-col cols="12" md="12">
            <v-data-table
               dense
               :headers="holiday_headers"
               :items="holidaydata"
               item-key="id"
               single-select
               @click:row="holidayRowClick"
            >
               <!-- eslint-disable-next-line -->
               <template #item.actions="{ item }">
                  <v-icon small @click="editHoliday(item)">mdi-pencil</v-icon>
                  <v-icon small @click="doDeleteHoliday(item)" class="ml-2">
                     mdi-delete
                  </v-icon>
               </template>
            </v-data-table>
         </v-col>
      </v-row>
      <holiday-form ref="holidayform" @input="onHolidayFormClose"></holiday-form>
      <show-toast ref="toast"></show-toast>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ShowToast from "@/components/showToast.vue";
   import HolidayForm from "@/components/HolidayForm.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         ConfirmDlg,
         ShowToast,
         HolidayForm,
      },

      data() {
         return {
            holiday_headers: [
               {
                  text: "Date",
                  value: "holiday_date",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Description",
                  value: "holiday_description",
                  width: "40%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            holidaydata: [],
         };
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         holidayRowClick(item, row) {
            row.select(!row.isSelected);
         },

         addHoliday() {
            this.$refs.holidayform.open(true);
         },

         editHoliday(item) {
            this.$refs.holidayform.edit(item);
         },

         onHolidayFormClose(payload) {
            if (payload.mode == "Add") {
               this.doAddHoliday(payload.holiday);
            } else if (payload.mode == "Edit") {
               this.doUpdateHoliday(payload.holiday);
            }
         },

         async doAddHoliday(holiday) {
            let response = await this.$http({
               url: "/common/addholiday.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  holiday: holiday,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadHoliday();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async doUpdateHoliday(holiday) {
            let response = await this.$http({
               url: "/common/updateholiday.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  holiday: holiday,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadHoliday();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async doDeleteHoliday(holiday) {
            let response = await this.$http({
               url: "/common/deleteholiday.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  holiday: holiday,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadHoliday();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async LoadHoliday() {
            let response = await this.$http({
               url: "/common/getpublicholiday.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.holidaydata = response.data.holidaydata;
                  }
               }
            });
         },
      },

      mounted() {
         this.LoadHoliday();
      },
   };
</script>
